import { render, staticRenderFns } from "./weixiujilu.vue?vue&type=template&id=5685abd8&scoped=true"
import script from "./weixiujilu.vue?vue&type=script&lang=js"
export * from "./weixiujilu.vue?vue&type=script&lang=js"
import style0 from "./weixiujilu.vue?vue&type=style&index=0&id=5685abd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685abd8",
  null
  
)

export default component.exports